import { Navigate } from 'react-router-dom';

import { useUserRole } from '@/hooks/useUserRole';

export const HomeRedirect = () => {
  const { canAccessAdmin, isAdvisor } = useUserRole();
  // Pure admin/super-admin (no advisor role) → admin console
  if (canAccessAdmin && !isAdvisor) return <Navigate to="/admin" replace />;
  // Advisors (including Advisor+Admin) → dashboard
  return <Navigate to="/dashboard" replace />;
};
